import { gql } from '@apollo/client';
import { RACE_FIELDS, RUNNER_FIELDS, RESULT_FIELDS, ANALYSIS_FIELDS } from '../fragments';

export const GET_RACES = gql`
  ${RACE_FIELDS}
  ${RUNNER_FIELDS}
  
  query GetRaces($meetingId: ID!) {
    races(meeting_id: $meetingId) {
      ...RaceFields
      runners {
        ...RunnerFields
      }
    }
  }
`;

export const GET_RACE = gql`
  ${RACE_FIELDS}
  ${RUNNER_FIELDS}
  ${RESULT_FIELDS}
  ${ANALYSIS_FIELDS}
  
  query GetRace($raceId: ID!) {
    race(race_id: $raceId) {
      ...RaceFields
      meeting {
        meeting_id
        race_count
        races {
          race_id
          race_number
        }
      }
      runners {
        ...RunnerFields
      }
      results {
        ...ResultFields
      }
      analysis {
        ...AnalysisFields
      }
      gear_changes {
        change_id
        horse_id
        horse_name
        tab_number
        gear_description
      }
      scratchings {
        race_id
        runner_id
        runner_name
        reason
        scratched_at
      }
    }
  }
`;
